import { auth } from '@monorepo/utils/firebase'
import { signOut as signOutFirebase } from '@monorepo/utils/firebase'
import { GoogleSignin } from '@react-native-google-signin/google-signin'
import { signInAnonymously } from '../signInAnonymously'

export const signOut = async ({ isAnonymousEnforced = true }) => {
  if (auth().currentUser) await signOutFirebase(auth())

  if (GoogleSignin.getCurrentUser()) GoogleSignin.signOut().catch(console.error)
  if (isAnonymousEnforced) {
    return await signInAnonymously()
  }
  return {
    user: null,
    provider: null,
  }
}
